<div class="common-layout {{ 'is-' + selectedHeaderColor }}"
    [ngClass]="{
        'is-folded': isFolded,
        'is-side-nav-dark' : isSideNavDark,
        'is-expand' : isExpand
    }"
>
    <app-header></app-header>
    <app-sidenav></app-sidenav>
    <div class="page-container">
        <div class="main-content">
            <div class="main-content-header" *ngIf="contentHeaderDisplay !== 'none'">
                <nz-breadcrumb nzSeparator=">">
                    <span class="m-r-5 text-gray" nz-icon nzType="home"></span>
                    <nz-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs$ | async">
                        <a (click)="linkClick(breadcrumb.url)">
                            {{ breadcrumb.label }}
                        </a>
                    </nz-breadcrumb-item>
                    <nz-breadcrumb-item *ngFor="let extra of breadcrumbExtra$ | async">
                        <a *ngIf="extra.action" (click)="extra.action()">
                            {{ extra.label }}
                        </a>
                        <span *ngIf="!extra.action" class="breadcrumb-extra-current">
                            {{ extra.label }}
                        </span>
                    </nz-breadcrumb-item>
                </nz-breadcrumb>
            </div>
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
</div>